import * as faceapi from 'face-api.js';

const MODELS_URL =
  process.env.REACT_APP_FACE_MODELS_URL || '/models';

let loaderPromise = null;

/**
 * Load SSD MobileNetV1 model weights một lần, cache promise.
 * Gọi nhiều lần an toàn.
 */
export async function loadFaceApiModels() {
  if (!loaderPromise) {
    loaderPromise = faceapi.nets.ssdMobilenetv1.loadFromUri(MODELS_URL);
  }
  return loaderPromise;
}

export { faceapi };
